export interface Nameable {
  public_id: string;
  name?: string | null;
  declared_name?: string | null;
}

/** The label people see for a data object: its name, else the upload filename, else the id. */
export function objectName(o: Nameable): string {
  return o.name || o.declared_name || o.public_id;
}
